export const RETURN_TO_PARAM = "returnTo";
const RETURN_TO_BASE = "https://return-to.invalid";

/**
 * Only allow same-origin absolute paths as a return destination — rejects
 * protocol-relative (`//evil.com`) and external URLs to avoid an open redirect.
 */
export function safeReturnTo(raw: string | null | undefined): string | null {
  if (!raw?.startsWith("/")) return null;
  const destination = sameOriginPath(raw);
  return destination !== null && sameOriginPath(destination) === destination ? destination : null;
}

function sameOriginPath(raw: string): string | null {
  let resolved: URL;
  try {
    resolved = new URL(raw, RETURN_TO_BASE);
  } catch {
    return null;
  }
  if (resolved.origin !== RETURN_TO_BASE) return null;
  return `${resolved.pathname}${resolved.search}${resolved.hash}`;
}

/** Read + validate the returnTo query param from the current client URL. */
export function readReturnTo(): string | null {
  if (typeof window === "undefined") return null;
  return safeReturnTo(new URLSearchParams(window.location.search).get(RETURN_TO_PARAM));
}
